// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3UhhN","dragIcon":"SortableItem_dragIcon__21oVm","disabled":"SortableItem_disabled__eEq_f"};